const GENERAL = 1;
const BY_OPTION = 2;

const getFeedbackTypeNameById = (id) => {
  return {
    1 : 'GENERAL',
    2 : 'BY_OPTION'
  }[id];
};

export default {
  GENERAL,
  BY_OPTION,
  getFeedbackTypeNameById
};
